module.exports = __webpack_public_path__ + "media/images/recruit/credo/img-brandslogan-c24634e376768715cfa5d00b3e75b026.svg";